import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { RootScopeService } from './root-scope.service';
import { Global } from '../global/globalApi';
import { HttpClient, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import * as Constants from '../models/Constants';
import { sAuthModel } from '../models/customer.model';
import { PrivacyPolicyService } from './privacy-policy.service';

@Injectable({
  providedIn: 'root'
})
export class AccountFreezeService {

  constructor(public rootScope: RootScopeService, private http: HttpClient, private privacyPolicyService: PrivacyPolicyService) { }

   /**
   * Sauth =true then only call the getPreAuthUserData API and then getALerts API should be triggered.
   * Sauth= false , directly call getALerts API .
   * CCR1-8142
   * @returns 
   */

  getAccountFreezeStatusFromServer() {

    let securityModel = this.rootScope.getSecurityModel(this.rootScope.activeCustTab.clientId);
    if (securityModel?.toLowerCase() == 'sauth') {

      /** CCR1-14396: Preserve existing sAuth state during desecure call to avoid resetting authentication progress */
      const sessionId = this.rootScope.activeCustTab.customerSessionId;
      const existingConfig = this.rootScope.authConfigUserDataMap?.[sessionId];

      if (existingConfig && typeof existingConfig === 'object' && 'SAuthStatus' in existingConfig) {
        this.rootScope.accountSAuthConfig = existingConfig;
      } else {
        this.rootScope.accountSAuthConfig = new sAuthModel();
        this.rootScope.accountSAuthConfig.SAuthStatus = true;
      }

      if (this.rootScope.activeCustTab.personStatus != 'NA') {
        this.rootScope.activeCustTab.loadDisplayAlertComp = true; /**Handling case of refresh the application for display alerts */
        return;
      }

      console.log('fraud invoking preAuth Config API', this.rootScope.activeCustTab);
      this.getData().subscribe({
        next: (data: any) => {
          if (data?.data && data?.data?.personStatus) {
            this.rootScope.activeCustTab.personStatus = data?.data?.personStatus;
            this.getPrivacyPolicyStatus(); /** Fetching Privacy policy status for the user */
          }
          this.rootScope.activeCustTab.loadDisplayAlertComp = true; /** Flag used for displayAlerts API call  */
        },
        error: (error) => {
          this.rootScope.activeCustTab.loadDisplayAlertComp = true;
        }
      });
    }
    else {
      /**If Sauth false , then direcly call getAlerts API */
      this.rootScope.activeCustTab.loadDisplayAlertComp  = true;
      this.getPrivacyPolicyStatus();
    }
  }

  getData() {

    let url = Global.domainUrl + Global.GET_PRE_AUTH_IDENTIFY_USER;
    let reqBody = {
      clientId: this.rootScope.activeCustTab.clientId
    }
    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
    });
  }

/** 
  * User Story -CCR3-12927
  * getPrivacyPolicyStatus() -- checking for privacy policy status.
  * @author :Amarjeet Kumar
  */
  getPrivacyPolicyStatus() {
    if (this.rootScope.isLiveCall && this.rootScope.activeCustTab.CS_SECURITY_LEVEL != Constants.securityLevels.SL4 && this.rootScope.isPrivacyPolicyConfigured()) {
      this.privacyPolicyService.getPrivacyPolicyStatus().subscribe({
        next: (res: any) => {
          if (res && res['data']) {
            let privacyData = JSON.parse(res['data']);
            this.rootScope.activeCustTab.privacyPolicyStatus = privacyData.message;
          }
        },
        error: (err) => {
          console.log(JSON.stringify(err));
        },
      });
    }
  }



}
